import { ButtonText } from 'shared/ui/buttons/buttonText';
import { PayloadAction } from '@reduxjs/toolkit';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { FC, useMemo } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { getWaitingOrders, selectBookingApplicationMod } from 'entities/orders';

import { Filters } from 'shared/lib/pagination';
import { getDateRangeFromToday } from 'shared/lib/datepicker';
import { selectSettingDefaultPerson } from 'entities/settings';
import { Person } from 'entities/person';
import { OrderBookingPerson } from 'entities/orders/model/types';

interface OrderDetailWaitingConfirmProps {
	dispatchToWaitingList: () => Promise<PayloadAction<unknown> | void>;
	onSuccessFetchData?: (filtersParam?: Filters) => void;
	person: Person | OrderBookingPerson;
	onClose?: () => void;
}

export const OrderDetailWaitingConfirm: FC<OrderDetailWaitingConfirmProps> = ({
	dispatchToWaitingList,
	onSuccessFetchData,
	person,
	onClose,
}) => {
  const ActionButtonTextWithFeedback = withAsyncActionFeedback(ButtonContained);

	const { openModal, closeModal } = useModal();
	const dispatch = useAppDispatch();
	const applictionMod = useAppSelector(selectBookingApplicationMod);
	const defaultPersonId = useAppSelector(selectSettingDefaultPerson);

	const getDateParams = () => {
		const [todayStart, todayEnd] = getDateRangeFromToday(true);
		return {
			dt_start__gte: todayStart.toISOString(),
			dt_end__lte: todayEnd.toISOString(),
			page: 1,
		};
	};

	const handleSuccess = async () => {
		onClose?.();
		dispatch(getWaitingOrders(getDateParams()));
		closeModal();
		onSuccessFetchData?.();
	};

	const handleClick = async () => {
		return dispatchToWaitingList();
	};

	const buttonTextName = useMemo(() => {
		return 'В лист ожидания';
	}, []);

	const handleBtnTextClick = () => {
		if (!applictionMod) {
			openModal();
		}
	};

	return (
		<>
			<Confirm
				title={'Перенести бронирование в лист ожидания?'}
				confirmButton={
					<ActionButtonTextWithFeedback
						onClick={handleClick}
						onSuccess={handleSuccess}
						successToastLabel={`Бронирование для гостя ${person?.name} перенесено в лист ожидания!`}
					>
						Да, перенести
					</ActionButtonTextWithFeedback>
				}
				cancelButtonLabel="Нет, оставить бронирование"
			/>
			{!applictionMod && (
				<ButtonText
					color="main"
					isFullWidth={true}
					onClick={handleBtnTextClick}
					disabled={!person?.name || person?.id === defaultPersonId}
				>
					{buttonTextName}
				</ButtonText>
			)}
		</>
	);
};
